const clearTextString = (textString) => {
  const removeAccents = textString.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const replaceSpaces = removeAccents.replaceAll(' ', '-');
  const lowercaseTextString = replaceSpaces.toLowerCase();

  return lowercaseTextString;
}

export default clearTextString;
